import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";

function ProjectCard(props) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="project" />

      <Card.Body>
        <Card.Title>{props.title}</Card.Title>

        <Card.Text className="project-description">
          {props.description}
        </Card.Text>

        {/* Tech Stack Badges */}
        {props.tech && (
          <div className="tech-stack">
            {props.tech.map((tech, index) => (
              <span key={index} className="tech-badge">
                {tech}
              </span>
            ))}
          </div>
        )}

        <div className="project-links">
          {props.ghLink && (
            <Button
              className="viewbtn"
              variant="primary"
              href={props.ghLink}
              target="_blank"
            >
              GitHub
            </Button>
          )}

          {!props.isBlog && props.demoLink && (
            <Button
              variant="primary"
              href={props.demoLink}
              target="_blank"
              style={{ marginLeft: "10px" }}
            >
              Live Demo
            </Button>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

export default ProjectCard;